<template>
  <div class="main-height bg-white">
    <SectionLayout :section-title="title" >
      <div class="list mt-2">
        <div class="list__item" :class="{'list__item--hide': isSubmitStep}">
          <AskHeading icon="profile" :title="$t('newonboarding.widget.submitStep.askJob')"/>
          <div class="list__item-wrap" :data-disabled="lockWhenSubmit">
            <GpRadioButton :key="index" v-for="(item, index) in listJobs" :label="item.label"
                           :value="item.value" v-model="jobSelected" @change="onChangeJobRole"/>
          </div>
          <input maxlength="255" :value="jobRoleText" @input="updateJobRoleValue"
                 v-if="showInputOther" class="input-other full-width invalid"
                 :placeholder="$t('newonboarding.widget.submitStep.askJob.placeholder')" type="text"/>
        </div>
        <div class="list__item">
          <AskHeading icon="tellus" :title="$t('newonboarding.widget.submitStep.askBusiness')"/>
          <div class="list__item-wrap" :data-disabled="lockWhenSubmit">
            <GpRadioButton :key="index" v-for="(item, index) in listBusiness" :label="item.label"
                           :value="item.value" v-model="businessSelected" @change="onChangeBusinessModel"/>
          </div>
        </div>
      </div>
    </SectionLayout>
    <button class="btn btn-light2 btn-block btn-sm btn-new-onboard-survey" :class="submittingStatus === 1 ? 'btn-light2-loading' : ''" :disabled="getButtonEnable()" @click="nextScreenOrSubmit">
        <span v-if="submittingStatus === 1" class="snack-loading">
          <i class="icon icon-loading"></i>
        </span>
      {{ actionLabel }}
    </button>
  </div>
</template>

<script>
import SectionLayout from "@/modules/Dashboard/components/NewDashboard/SectionLayout";
import GpRadioButton from "@/core/shared/GpForms/components/GpRadioButton";
import {mapActions, mapGetters} from "vuex";
import {actions as obActions} from "@/store/newonboarding/types";
import AskHeading from "@/modules/Dashboard/components/NewDashboard/SurveyOnBoard/Components/AskHeading";

export default {
  name: "Step2",
  components: {
    SectionLayout,
    GpRadioButton,
    AskHeading
  },
  data() {
    return {
      jobSelected: [],
      businessSelected: [],
      lockWhenSubmit: false,
      listJobs: [
        {
          label: this.$t('newonboarding.widget.submitStep.job.businessowner'),
          value: "owner"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.soloEnterpreneur'),
          value: "solo"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.employee'),
          value: "employee"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.freelancer'),
          value: "freelancer"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.other'),
          value: "other"
        }
      ],
      listBusiness: [
        {
          label: this.$t('newonboarding.widget.submitStep.job.dropshipping'),
          value: "dropshipping"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.manufacturing'),
          value: "manufacturing"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.direct'),
          value: "direct"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.wholesale'),
          value: "wholesale"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.print'),
          value: "print"
        },
        {
          label: this.$t('newonboarding.widget.submitStep.job.subscription'),
          value: "subscription"
        }
      ],
      showInputOther: false,
      enableNextStep: false
    };
  },
  computed: {
    title() {
      return this.$t('newonboarding.widget.submitStep.title');
    },
    actionLabel() {
      const jobRole = this.jobSelected[0];
      if (this.isSubmitStep || jobRole === "freelancer") {
        return this.$t('newonboarding.widget.submitStep.sendToEmailButton');
      }
      return this.$t('newonboarding.widget.submitStep.nextButton');
    },
    ...mapGetters("newonboarding", {
      jobRole: "jobRole",
      businessType: "businessType",
      currentStep: "currentStep",
      isSubmitStep: "isSubmitStep",
      submittingStatus: "submittingStatus",
      jobRoleText: "jobRoleText"
    }),
  },
  mounted() {
    // Set current value for job role
    if (this.jobRole) {
      this.jobSelected.push(this.jobRole);
    }
    // Set current value for business type
    if (this.businessType) {
      this.businessSelected.push(this.businessType);
    }

    this.isShowInputOther();
    this.checkButtonEnabled();
  },
  methods: {
    getButtonEnable() {
      return !this.enableNextStep;
    },
    checkButtonEnabled() {
      // If submitting then disable button
      if (this.lockWhenSubmit) {
        this.enableNextStep = false;
        return;
      }

      // Job selected
      if (!this.isSubmitStep && this.jobSelected.length !== 0) {
        this.enableNextStep = this.validateJobOtherInput();
      }
      // Business model selected
      else if (this.isSubmitStep && this.businessSelected.length !== 0) {
        this.enableNextStep = true;
      } else {
        this.enableNextStep = false;
      }
    },
    validateJobOtherInput() {
      const jobSelected = this.jobSelected[0];
      if (jobSelected === "other" && this.jobRoleText.trim().length === 0) {
        return false;
      }
      return true;
    },
    onChangeJobRole() {
      const jobRole = this.jobSelected[0];
      this.onUpdateJobRole({value: jobRole});
      this.isShowInputOther();
      this.checkButtonEnabled();
    },
    onChangeBusinessModel() {
      if (!this.lockWhenSubmit) {
        const businessType = this.businessSelected[0];
        this.onUpdateBusinessType({value: businessType});
        this.checkButtonEnabled();
      }
    },
    isShowInputOther() {
      if (this.jobSelected[0] === "other") {
        this.showInputOther = true;
      } else {
        this.showInputOther = false;
      }
    },
    ...mapActions("newonboarding", {
      onGotoStep: obActions.GO_TO_STEP,
      onUpdateJobRole: obActions.UPDATE_JOB_ROLE,
      onUpdateBusinessType: obActions.UPDATE_BUSINESS_TYPE,
      onUpdateSubmitStep: obActions.UPDATE_IS_SUBMIT_STEP,
      onUpdateSubmittingStatus: obActions.UPDATE_SUBMITTING_STATUS,
      lastStepSubmit: obActions.LAST_STEP_SUBMIT,
      onUpdateJobRoleValue: obActions.UPDATE_JOB_ROLE_VALUE
    }),
    updateJobRoleValue(e) {
      const value = e.target.value;
      this.onUpdateJobRoleValue({value});
      this.checkButtonEnabled();
    },
    nextScreenOrSubmit() {
      // Last step
      if (this.isSubmitStep) {
        this.submitAndDisableButton();
      } else if (this.jobSelected[0] === "freelancer") {
        this.submitAndDisableButton();
      } else if (this.jobSelected[0] === "other") {
        this.validateInputOtherJob();
      } else {
        // Trượt tới màn kế tiếp
        this.gotoBusinessModelChoice();
      }

      this.checkButtonEnabled();
    },
    submitAndDisableButton() {
      this.submitData();
    },
    validateInputOtherJob() {
      // Validate input here
      this.gotoBusinessModelChoice();
    },
    gotoBusinessModelChoice() {
      this.onUpdateSubmitStep(true);
    },
    submitData() {
      this.lockScreen();
      this.onUpdateSubmittingStatus(1);
      setTimeout(() => {
        this.lastStepSubmit();
      }, 1000);
      // this.onUpdateSubmitStep(false); // Test trượt về
    },
    lockScreen() {
      this.lockWhenSubmit = true;
    }
  }
}
</script>

<style lang="scss" scoped>

.list {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  overflow: hidden;

  &__item {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
    margin-left: 0%;
    opacity: 1;
    overflow: hidden;

    &--hide {
      margin-left: -100%;
      opacity: 0;
    }

    &-wrap[data-disabled=true] {
      opacity: 0.5;
      pointer-events: none;
    }
  }

  ::v-deep.gp-checkbox-text {
    color: $dark6;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-left: 5px !important;
  }

  ::v-deep.gp-checkbox-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    ::v-deep.svg {
    }
  }
}

.input-other {
  border: 1px solid #3C67FF;
  height: 32px;
  border-radius: 3px;

  ::placeholder {
    font-size: 12px;
  }
}

.snack-loading {
  width: 24px;
  height: 24px;
  animation: cog 1s infinite;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon-loading {
    color: $textLightModeHigh;
  }
}

@keyframes cog {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
